var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('div',{staticClass:"reverse-on-mobile"},[_c('WelcomeBanner'),_c('SearchPharmacies')],1),_c('AboutTeraphy'),_c('ParticipantsSavings'),_c('BecomeMember'),_c('GetBenefits'),_c('ProgramRules'),_c('CreateAccount'),_c('Faq'),_c('Feedback')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }